// The order of these keys matter, it determines the order
// in which they are displayed on the Mail Search Page
export default {
    all: { id: 0, friendly: 'All' },
    completed: { id: 1, friendly: 'Completed' },
    open: { id: 2, friendly: 'Open' },
    voided: { id: 3, friendly: 'Voided' },
};
